import { motion } from "framer-motion";

const CHAPTERS = [
  { num: "01", title: "Garanzia di autenticità", desc: "Ogni box o carta singola viene ispezionata per garantirne l'autenticità." },
  { num: "02", title: "Omnichannel loyalty", desc: "I tuoi vantaggi sono gli stessi sia se acquisti online oppure in negozio. Mostra la tua tessera in cassa e accumula i punti sui tuoi acquisti." },
  { num: "03", title: "Gradi e ricompense", desc: "Con noi puoi crescere e scalando 5 gradi di avanzamento (da Bronzo a Diamante) sbloccherai sconti riservati, vantaggi sulle edizioni limitate e su tanti altri premi." },
];

export default function Manifesto() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-24 sm:py-32">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-xs font-mono uppercase tracking-[0.25em] text-red-500 font-semibold mb-4"
      >
        Il manifesto
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="text-2xl sm:text-3xl lg:text-4xl font-display font-extrabold uppercase tracking-tight text-white mb-16"
      >
        Perché i collezionisti <span className="text-red-600">scelgono Wanted</span>
      </motion.h2>

      <div className="grid md:grid-cols-3 gap-6">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${c.num}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.15, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="slab-frame rounded-xl p-8 group"
          >
            <span className="font-mono text-xs text-red-500/90 tracking-widest uppercase border border-red-500/30 px-2 py-0.5 rounded">
              {c.num}
            </span>
            <h3 className="text-xl sm:text-2xl font-display font-bold tracking-tight text-white mt-6 mb-4 uppercase">
              {c.title}
            </h3>
            <p className="text-xs font-mono uppercase tracking-[0.15em] text-zinc-400 leading-loose">{c.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
